module.exports = __webpack_public_path__ + "static/img/5523_phase_function_Paper_Points.c016aa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5523_phase_function_Paper_Points.png
// module id = ew9e
// module chunks = 0